import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { BehaviorSubject } from "rxjs";
import { CoachMarkConfig } from "src/app/components/coach-mark/coach-mark.component";
import { setEncouragementEventPopoverIds, setEncouragementShown, setEncouragementShownBulk } from "src/store/actions/encouragement";
import { CommonService } from "../common/common.service";
import { ConstantService } from "../constant/constant.service";

@Injectable({ providedIn: 'root' })
export class EncouragementService {
    private configSubject = new BehaviorSubject<CoachMarkConfig | null>(null);
    readonly config$ = this.configSubject.asObservable();
    private activePopoverId: string | null = null;
    private shown = {};
    private eventPopoverIds = {} as { [event: string]: string[] };

    constructor(
        private common: CommonService,
        private constant: ConstantService,
        private store: Store<any>
    ) {
        this.store
            .select((s: any) => s.user?.user?.encouragementShown)
            .subscribe((shown) => {
                if (shown && typeof shown === 'object') {
                    this.store.dispatch(setEncouragementShownBulk(shown));
                }
            });
        
        this.store.select((s: any) => s.encouragementData).subscribe((d) => {
            this.shown = d?.encouragementShown || {};
            this.eventPopoverIds = d?.eventPopoverIds || {};
        });
    }

    handleApiReponse(response: any): boolean {
        const popover = response?.encouragementPopover;
        if (!popover?.popoverId) return false;

        this.activePopoverId = popover.popoverId;

        this.configSubject.next({
            id: popover.popoverId,
            title: popover.title || '',
            body: popover.body || '',
            ctaText: popover.buttonText || 'Got it',
            hideArrow: true,
            tooltipPosition: 'center',
            targetSelector: '#encouragement-popover-target',
        });

        return true;
    }

    get isShowing(): boolean {
        return !!this.configSubject.value;
    }

    hydrateConfig(): void {
        this.common.callApi(this.constant.ENCOURAGEMENT_CONFIG, '', 'GET', '', false, false, true)
          .subscribe({
            next: (res) => this.store.dispatch(setEncouragementEventPopoverIds(res?.eventPopoverIds || {})),
            error: (e) => console.error('Encouragement config failed', e),
          });
    }

    shouldSkip(eventName: string): boolean {
        const ids = this.eventPopoverIds[eventName];
        return !!ids?.length && ids.every((id) => this.shown[id] === true);
    }

    onDismissed(): void {
        const popoverId = this.activePopoverId;
        this.activePopoverId = null;
        this.configSubject.next(null);

        if (!popoverId) return;

        this.store.dispatch(setEncouragementShown(popoverId));

        this.common.callApi(
            this.constant.UPDATE_USER_ENCOURAGEMENT,
            { popoverId },
            'PUT',
            '',
            false,
            false,
            true
        ).subscribe({
            error: (error) => console.error('Encouragement mark shown failed: ', error),
        });
    }
}